<template>
  <base-code-message
      :message="message"
      :run="run"
      :can-stop="false">
  </base-code-message>
</template>

<script>
import OnlineJudgePython from '@/plugin/web_ide/OjPython'
import BaseCodeMessage from '@/components/classroom/messages/partials/BaseCodeMessage'

export default {
  components: { BaseCodeMessage },
  props: ['message'],
  data () {
    return {
      python: null
    }
  },
  methods: {
    async run (code, shell) {
      if (!code || shell.status === 'running') return
      this.python = new OnlineJudgePython(this, shell)
      this.python.run(code, shell, this.message.data.attachments)
    }
  }
}
</script>
